import React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircleIcon from "@mui/icons-material/Circle";

const Banner = () => {
  const ColorButton = styled(Button)(() => ({
    color: "#000",
    width: 225,
    height: 65,
    fontWeight: 600,
    fontSize: "16px",
    textTransform: "capitalize",
    backgroundColor: "#fff",
    borderColor: "#fff",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#4f4f4f",
      borderColor: "#000",
    },
  }));

  return (
    <Box
      width={{ xs: "100%", sm: "75%" }}
      margin={{ xs: "30% 0% 15% 0%", sm: "10% 0%" }}
      marginLeft={{ xs: "0%", sm: "0%" }}
    >
      <Box>
        <Typography
          variant={"h2"}
          fontWeight={700}
          textAlign={"left"}
          color={"#fff"}
          display={{ xs: "none", sm: "block" }}
        >
          Our team is made up of innovative designers and developers who help
          organizations to build{" "}
          <Typography
            component={"span"}
            variant={"h2"}
            color="#33E68C"
            fontWeight={700}
          >
            great
          </Typography>{" "}
          products.
        </Typography>
        <Typography
          variant={"h3"}
          fontWeight={700}
          textAlign={"left"}
          color={"#fff"}
          display={{ xs: "block", sm: "none" }}
        >
          Our team is made up of innovative designers and developers who help
          organizations to build{" "}
          <Typography
            component={"span"}
            variant={"h3"}
            color="#33E68C"
            fontWeight={700}
          >
            great
          </Typography>{" "}
          products.
        </Typography>
        <Box padding={"6% 2% 1% 0%"}>
          <ColorButton
            component={"a"}
            variant="outlined"
            size="medium"
            href={"/contact-us"}
            endIcon={
              <CircleIcon
                sx={{
                  color: "#33E68C",
                  "&:hover": {
                    color: "#fff",
                  },
                }}
              />
            }
          >
            Let's Talk
          </ColorButton>
        </Box>
      </Box>
    </Box>
  );
};

export default Banner;
